import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        menu: false,
        token: '',
        userInfo: null,
        infoTitle: '',
        pageShow:true,
        mingcheng:{},
    },
    getters: {
        menu: state => state.menu,
        token: state => state.token,
        userInfo: state => state.userInfo,
        infoTitle: state => state.infoTitle,
        pageShow: state => state.pageShow,
        mingcheng: state => state.mingcheng,
    },
    mutations: {
        SET(state, data) {
            // console.log(data);
            for(let i in data){
                state[i] = data[i];
            }
        },
    },
})



// WEBPACK FOOTER //
// ./src/store/index.js